import { render, staticRenderFns } from "./ChatTour.vue?vue&type=template&id=3da7a8cd&"
import script from "./ChatTour.vue?vue&type=script&lang=js&"
export * from "./ChatTour.vue?vue&type=script&lang=js&"
import style0 from "./ChatTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports